export default __webpack_public_path__ + "static/media/353.cc75093b.png";